import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Es difícil de seguir?',
    a: 'No, son alimentos reales que encontrás en cualquier supermercado o dietética de Argentina.'
  }, {
    q: '¿Puedo tomar mate?',
    a: 'El protocolo explica cómo y en qué momento tomarlo para que no te inflame.'
  }, {
    q: '¿Tengo que comprar suplementos caros?',
    a: 'No, el 90% del éxito se basa en alimentos y sales naturales.'
  }, {
    q: '¿Es seguro si tengo menopausia?',
    a: 'Es ideal, está diseñado específicamente para ese cambio hormonal.'
  }, {
    q: '¿El acceso es para siempre?',
    a: 'Sí, una vez que comprás en Hotmart, el material es tuyo de por vida.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 md:py-32 bg-sage/20" data-id="element-15">
      <div className="max-w-3xl mx-auto px-6 md:px-12" data-id="element-16">
        <FadeIn data-id="element-17">
          <div className="text-center mb-16" data-id="element-18">
            <h2 className="font-serif text-3xl md:text-4xl text-teal" data-id="element-19">
              Preguntas Frecuentes
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-20">
          {faqs.map((faq, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-21">
              <div className="bg-white rounded-lg border border-teal/5 overflow-hidden" data-id="element-22">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-23">
                  <span className="font-serif text-lg text-teal pr-4" data-id="element-24">
                    {faq.q}
                  </span>
                  <ChevronDown className={`text-gold transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-25" />
                </button>
                <AnimatePresence data-id="element-26">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-27">
                      <div className="px-6 pb-6 pt-0" data-id="element-28">
                        <p className="text-teal/70 font-light leading-relaxed" data-id="element-29">
                          {faq.a}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}